import {
  isSharesProject,
  Project,
} from "@tudigo-monorepo/core-tudigo-api-models";
import { formatCurrency } from "@tudigo-monorepo/core-tudigo-utils";

import { ProjectInfoCardItem } from "../../../../shared-internal/components/project-info-card-item";

export function CommonProjectModalities(props: { project: Project }) {
  const { project } = props;

  const { entryFees, managementFees } = getFeesForProject(project);

  const carried = isSharesProject(project)
    ? project.sharesMechanicSettings.carriedNoDecimalRate / 100
    : 0;

  return (
    <>
      <ProjectInfoCardItem
        label="Montant plancher"
        value={
          project.goal ? formatCurrency(project.goal?.minInCents) : "Non défini"
        }
      />
      <ProjectInfoCardItem
        label="Montant maximum recherché"
        value={
          project.goal ? formatCurrency(project.goal?.maxInCents) : "Non défini"
        }
      />
      <ProjectInfoCardItem
        label="Stades de maturité"
        value={project.maturity?.name ?? "Non défini"}
      />
      {entryFees ? (
        <ProjectInfoCardItem
          label="Frais d'investissement"
          value={`${entryFees} %`}
        />
      ) : null}
      {managementFees ? (
        <ProjectInfoCardItem
          label="Frais de gestion et de fonctionnement"
          value={`${managementFees} %`}
        />
      ) : null}
      {carried ? (
        <ProjectInfoCardItem label="Carried" value={`${carried} %`} />
      ) : null}
    </>
  );
}

function getFeesForProject(project: Project) {
  const { transactionFees, managementFees, operatingFees } = project;

  // Case where tiers are available (new fees logic)
  if (transactionFees?.tiers) {
    const { tiers } = transactionFees;
    const tiersLength = tiers.length;
    const entryFeesMin = (tiers[tiersLength - 1].noDecimalRate ?? 0) / 100;
    const entryFeesMax = (tiers[0].noDecimalRate ?? 0) / 100;
    const entryFees = `De ${entryFeesMin} à ${entryFeesMax}`;
    const totalManagementFees =
      ((managementFees?.noDecimalRate ?? 0) +
        (operatingFees?.noDecimalRate ?? 0)) /
      100;

    return { entryFees, managementFees: totalManagementFees };
  }

  // Case where tiers are not available (old fees logic)
  const feesSource = isSharesProject(project)
    ? project.sharesMechanicSettings
    : project.bondsMechanicSettings;

  const entryFees = feesSource.entryFeesNoDecimalRate / 100;

  return {
    entryFees,
    managementFees: feesSource.managementFeesNoDecimalRate / 100,
  };
}
